// extracted by mini-css-extract-plugin
module.exports = {"appPanelCardWrap":"style_appPanelCardWrap__Fb9aP","list":"style_list__RSaNc","titleCardItem":"style_titleCardItem__rCv87"};